const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  hiId: state => state.user.hiId,
  hiName: state => state.user.hiName,
  userCode: state => state.user.userCode,
  userName: state => state.user.userName,
  phone: state => state.user.phone,
  roles: state => state.user.roles,
  permissions: state => state.user.permissions,

  // bookName: state => state.user.bookName,
  // nickName: state => state.user.nickName,
  // baseRoutingUrl: state => state.user.baseRoutingUrl,
  // businessLevel: state => state.user.businessLevel,
  // introduction: state => state.user.introduction,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js